import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, Transition as _Transition, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" clear selection ")
const _hoisted_2 = { id: "loading" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Loading...", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "This visualization requires many megabytes and may take up to a minute to render.", -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { class: "row" }
const _hoisted_7 = {
  id: "label-wrapper",
  class: "col-2"
}
const _hoisted_8 = { id: "matrix-labels" }
const _hoisted_9 = { class: "align-top label-grid" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Single View")
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "q-k attention patterns for a single head", -1)
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Matrix View")
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, "q-k attention patterns for all attention heads", -1)
const _hoisted_16 = {
  id: "attn-msg",
  class: "subtitle"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "head-axis" }, "head →", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "layer-axis" }, "layer ↓", -1)
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = { class: "label-grid" }
const _hoisted_21 = { class: "label" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Model")
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", null, "transformer options:", -1)
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" (")
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { key: 2 }
const _hoisted_28 = { key: 3 }
const _hoisted_29 = /*#__PURE__*/_createTextVNode(") ")
const _hoisted_30 = { class: "label" }
const _hoisted_31 = /*#__PURE__*/_createTextVNode("Projection")
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", null, "projection methods for creating joint q-k embeddings", -1)
const _hoisted_33 = { class: "label" }
const _hoisted_34 = /*#__PURE__*/_createTextVNode("Search")
const _hoisted_35 = /*#__PURE__*/_createTextVNode("search for ")
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { key: 1 }
const _hoisted_38 = /*#__PURE__*/_createTextVNode("clear")
const _hoisted_39 = { class: "label" }
const _hoisted_40 = /*#__PURE__*/_createTextVNode("Show")
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", null, "overlay options:", -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("i", null, "labels", -1)
const _hoisted_43 = /*#__PURE__*/_createTextVNode(": ")
const _hoisted_44 = { key: 0 }
const _hoisted_45 = { key: 1 }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("i", null, "attention lines"),
  /*#__PURE__*/_createTextVNode(": top 2 connections for each token; line opacity denotes attention weight")
], -1)
const _hoisted_47 = { style: {"width":"235px"} }
const _hoisted_48 = /*#__PURE__*/_createTextVNode("labels")
const _hoisted_49 = /*#__PURE__*/_createTextVNode("attention lines")
const _hoisted_50 = { class: "label" }
const _hoisted_51 = /*#__PURE__*/_createTextVNode("Dot Size")
const _hoisted_52 = /*#__PURE__*/_createElementVNode("span", null, "scale dots in scatterplot by token embedding norm", -1)
const _hoisted_53 = /*#__PURE__*/_createTextVNode("scale by norm")
const _hoisted_54 = { class: "label-grid" }
const _hoisted_55 = { class: "label" }
const _hoisted_56 = /*#__PURE__*/_createTextVNode("Color")
const _hoisted_57 = /*#__PURE__*/_createElementVNode("span", null, "color encodings:", -1)
const _hoisted_58 = { class: "label" }
const _hoisted_59 = /*#__PURE__*/_createTextVNode("Mode")
const _hoisted_60 = /*#__PURE__*/_createElementVNode("span", null, "view plots in 2D or 3D", -1)
const _hoisted_61 = /*#__PURE__*/_createTextVNode("2D")
const _hoisted_62 = /*#__PURE__*/_createTextVNode("3D")
const _hoisted_63 = { class: "label italic" }
const _hoisted_64 = {
  id: "num-msg",
  class: "subtitle"
}
const _hoisted_65 = /*#__PURE__*/_createElementVNode("b", null, "data info:", -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("span", null, "object labels are generated from a segmentation model and may not be 100% accurate", -1)
const _hoisted_67 = { class: "label" }
const _hoisted_68 = /*#__PURE__*/_createTextVNode("View Adjacent Head")
const _hoisted_69 = /*#__PURE__*/_createElementVNode("span", null, "explore an adjacent attention head", -1)
const _hoisted_70 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("i", null, "up"),
    /*#__PURE__*/_createTextVNode(": move up 1 layer")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("i", null, "left"),
    /*#__PURE__*/_createTextVNode(": move left 1 head")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("i", null, "right"),
    /*#__PURE__*/_createTextVNode(": move right 1 head")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("i", null, "down"),
    /*#__PURE__*/_createTextVNode(": move down 1 layer")
  ])
], -1)
const _hoisted_71 = { id: "control-buttons" }
const _hoisted_72 = { class: "arrow-group center" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("div", {
  id: "matrix-wrapper",
  class: "col-10"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "gradient-edge" }),
  /*#__PURE__*/_createElementVNode("div", { class: "gradient-edge right" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_Circle = _resolveComponent("Circle")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_Legend = _resolveComponent("Legend")!
  const _component_DataGrid = _resolveComponent("DataGrid")!
  const _component_ArrowUpOutlined = _resolveComponent("ArrowUpOutlined")!
  const _component_ArrowLeftOutlined = _resolveComponent("ArrowLeftOutlined")!
  const _component_ArrowRightOutlined = _resolveComponent("ArrowRightOutlined")!
  const _component_ArrowDownOutlined = _resolveComponent("ArrowDownOutlined")!
  const _component_MatrixView = _resolveComponent("MatrixView")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        _withDirectives(_createVNode(_component_a_button, {
          type: "default",
          id: "clear-attn",
          onClick: _ctx.clearSelection
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }, 8, ["onClick"]), [
          [_vShow, !_ctx.renderState && (_ctx.view == 'attn' || _ctx.view == 'search')]
        ])
      ]),
      _: 1
    }),
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_2, _hoisted_5, 512), [
          [_vShow, _ctx.renderState]
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_Transition, null, {
          default: _withCtx(() => [
            _withDirectives(_createVNode(_component_Circle, null, null, 512), [
              [_vShow, _ctx.attnLoading || _ctx.transitionInProgress]
            ])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", null, [
              (_ctx.mode === "single")
                ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
                    _hoisted_11,
                    _createVNode(_component_a_tooltip, { placement: "rightTop" }, {
                      title: _withCtx(() => [
                        _hoisted_12
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, {
                          icon: "info",
                          class: "info-icon"
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_Transition, null, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, "(" + _toDisplayString("Layer " + _ctx.curLayer + " Head " + _ctx.curHead) + ")", 1)
                      ]),
                      _: 1
                    })
                  ]))
                : (_openBlock(), _createElementBlock("p", _hoisted_13, [
                    _hoisted_14,
                    _createVNode(_component_a_tooltip, { placement: "rightTop" }, {
                      title: _withCtx(() => [
                        _hoisted_15
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, {
                          icon: "info",
                          class: "info-icon"
                        })
                      ]),
                      _: 1
                    })
                  ])),
              _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.attnMsg), 1)
            ]),
            _createVNode(_Transition, null, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("p", {
                  class: _normalizeClass(["axis-label", { hide: _ctx.mode === 'single' }])
                }, _hoisted_19, 2), [
                  [_vShow, _ctx.mode !== 'single']
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", null, [
              _createElementVNode("p", _hoisted_21, [
                _hoisted_22,
                _createVNode(_component_a_tooltip, { placement: "right" }, {
                  title: _withCtx(() => [
                    _hoisted_23,
                    _createElementVNode("ul", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modelOptions, (option) => {
                        return (_openBlock(), _createElementBlock("li", null, [
                          _createElementVNode("i", null, _toDisplayString(option.value), 1),
                          _hoisted_24,
                          (option.value.includes('vit'))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_25, "vision"))
                            : _createCommentVNode("", true),
                          (option.value.includes('nat'))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_26, ", natural images"))
                            : _createCommentVNode("", true),
                          (option.value.includes('syn'))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_27, ", synthetic images"))
                            : _createCommentVNode("", true),
                          (['bert', 'gpt-2'].includes(option.value))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_28, "language"))
                            : _createCommentVNode("", true),
                          _hoisted_29
                        ]))
                      }), 256))
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "info",
                      class: "info-icon"
                    })
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_a_select, {
                value: _ctx.modelType,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modelType) = $event)),
                style: {"width":"115px"},
                options: _ctx.modelOptions
              }, null, 8, ["value", "options"])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("p", _hoisted_30, [
                _hoisted_31,
                _createVNode(_component_a_tooltip, { placement: "right" }, {
                  title: _withCtx(() => [
                    _hoisted_32
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "info",
                      class: "info-icon"
                    })
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_a_select, {
                value: _ctx.projectionMethod,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.projectionMethod) = $event)),
                style: {"width":"115px"},
                options: _ctx.projectionMethods
              }, null, 8, ["value", "options"])
            ])
          ]),
          _createElementVNode("p", _hoisted_33, [
            _hoisted_34,
            _createVNode(_component_a_tooltip, { placement: "rightBottom" }, {
              title: _withCtx(() => [
                _createElementVNode("span", null, [
                  _hoisted_35,
                  (!_ctx.modelType.includes('vit'))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_36, "a token"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_37, "an object"))
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, {
                  icon: "info",
                  class: "info-icon"
                })
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_a_input_search, {
            value: _ctx.searchToken,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchToken) = $event)),
            placeholder: _ctx.placeholder,
            "enter-button": "",
            onSearch: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onSearch(_ctx.searchToken))),
            spellcheck: "false"
          }, null, 8, ["value", "placeholder"]),
          _createVNode(_Transition, null, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(_component_a_button, {
                class: "clear",
                type: "link",
                onClick: _ctx.clearSearch
              }, {
                default: _withCtx(() => [
                  _hoisted_38
                ]),
                _: 1
              }, 8, ["onClick"]), [
                [_vShow, _ctx.searchToken != '']
              ])
            ]),
            _: 1
          }),
          _createElementVNode("p", _hoisted_39, [
            _hoisted_40,
            _createVNode(_component_a_tooltip, {
              placement: "rightTop",
              class: _normalizeClass({ disabled: _ctx.mode === 'matrix' })
            }, {
              title: _withCtx(() => [
                _hoisted_41,
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, [
                    _hoisted_42,
                    _hoisted_43,
                    (!_ctx.modelType.includes('vit'))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_44, "token label (e.g., cat, april)"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_45, "object label (e.g., background, person)"))
                  ]),
                  _hoisted_46
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, {
                  icon: "info",
                  class: "info-icon"
                })
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _createElementVNode("div", _hoisted_47, [
            _createVNode(_component_a_checkbox, {
              checked: _ctx.showAll,
              "onUpdate:checked": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showAll) = $event)),
              class: _normalizeClass({ disabled: _ctx.mode == 'matrix' })
            }, {
              default: _withCtx(() => [
                _hoisted_48
              ]),
              _: 1
            }, 8, ["checked", "class"]),
            _createVNode(_component_a_checkbox, {
              checked: _ctx.showAttention,
              "onUpdate:checked": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showAttention) = $event)),
              class: _normalizeClass({ disabled: _ctx.mode == 'matrix' || _ctx.view != 'attn' })
            }, {
              default: _withCtx(() => [
                _hoisted_49
              ]),
              _: 1
            }, 8, ["checked", "class"])
          ]),
          _createElementVNode("p", _hoisted_50, [
            _hoisted_51,
            _createVNode(_component_a_tooltip, {
              placement: "rightBottom",
              class: _normalizeClass({ disabled: _ctx.mode === 'matrix' || _ctx.modelType.includes('vit') })
            }, {
              title: _withCtx(() => [
                _hoisted_52
              ]),
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, {
                  icon: "info",
                  class: "info-icon"
                })
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _createVNode(_component_a_checkbox, {
            checked: _ctx.sizeByNorm,
            "onUpdate:checked": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.sizeByNorm) = $event)),
            class: _normalizeClass({
                        disabled: _ctx.mode == 'matrix' || _ctx.modelType.includes('vit')
                    })
          }, {
            default: _withCtx(() => [
              _hoisted_53
            ]),
            _: 1
          }, 8, ["checked", "class"]),
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("div", null, [
              _createElementVNode("p", _hoisted_55, [
                _hoisted_56,
                _createVNode(_component_a_tooltip, { placement: "rightTop" }, {
                  title: _withCtx(() => [
                    _hoisted_57,
                    _createElementVNode("ul", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colorByDict, (item, key) => {
                        return (_openBlock(), _createElementBlock("li", null, [
                          _createElementVNode("i", null, _toDisplayString(item.label), 1),
                          _createTextVNode(": " + _toDisplayString(item.desc), 1)
                        ]))
                      }), 256))
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "info",
                      class: "info-icon"
                    })
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_a_select, {
                value: _ctx.colorBy,
                "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.colorBy) = $event)),
                style: {"width":"135px"},
                options: _ctx.colorByOptions
              }, null, 8, ["value", "options"])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("p", _hoisted_58, [
                _hoisted_59,
                _createVNode(_component_a_tooltip, { placement: "rightBottom" }, {
                  title: _withCtx(() => [
                    _hoisted_60
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "info",
                      class: "info-icon"
                    })
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_a_radio_group, {
                value: _ctx.dimension,
                "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.dimension) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_radio_button, { value: "2D" }, {
                    default: _withCtx(() => [
                      _hoisted_61
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_radio_button, { value: "3D" }, {
                    default: _withCtx(() => [
                      _hoisted_62
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"]),
              _createVNode(_Transition, null, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("p", _hoisted_63, " click a head to see full 3D", 512), [
                    [_vShow, _ctx.dimension === '3D' && _ctx.mode === 'matrix']
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _createVNode(_component_Legend, { ref: "legend" }, null, 512),
          _createVNode(_Transition, null, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("div", null, [
                _createElementVNode("p", _hoisted_64, [
                  _hoisted_65,
                  _createTextVNode(" based on " + _toDisplayString(_ctx.num_message), 1),
                  _withDirectives(_createElementVNode("span", null, [
                    _createVNode(_component_a_tooltip, { placement: "rightTop" }, {
                      title: _withCtx(() => [
                        _hoisted_66
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, {
                          icon: "info",
                          class: "info-icon"
                        })
                      ]),
                      _: 1
                    })
                  ], 512), [
                    [_vShow, _ctx.modelType.includes('vit') && _ctx.modelType != 'vit-syn']
                  ])
                ]),
                _createVNode(_Transition, null, {
                  default: _withCtx(() => [
                    _withDirectives(_createVNode(_component_DataGrid, { ref: "dataGrid" }, null, 512), [
                      [_vShow, _ctx.modelType.includes('vit') && _ctx.mode === 'single']
                    ])
                  ]),
                  _: 1
                })
              ], 512), [
                [_vShow, !_ctx.renderState]
              ])
            ]),
            _: 1
          }),
          _createVNode(_Transition, null, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("div", null, [
                _createElementVNode("p", _hoisted_67, [
                  _hoisted_68,
                  _createVNode(_component_a_tooltip, { placement: "rightTop" }, {
                    title: _withCtx(() => [
                      _hoisted_69,
                      _hoisted_70
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_font_awesome_icon, {
                        icon: "info",
                        class: "info-icon"
                      })
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_71, [
                  _createVNode(_component_a_button, {
                    class: _normalizeClass(["center", { disabled: _ctx.layer < 1 }]),
                    type: "default",
                    size: "small",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.moveToPlot('up'))),
                    disabled: _ctx.layer < 1
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_component_ArrowUpOutlined)
                    ]),
                    _: 1
                  }, 8, ["class", "disabled"]),
                  _createElementVNode("div", _hoisted_72, [
                    _createVNode(_component_a_button, {
                      type: "default",
                      size: "small",
                      class: _normalizeClass({ disabled: _ctx.head < 1 }),
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.moveToPlot('left'))),
                      disabled: _ctx.head < 1
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_ArrowLeftOutlined)
                      ]),
                      _: 1
                    }, 8, ["class", "disabled"]),
                    _createVNode(_component_a_button, {
                      type: "default",
                      size: "small",
                      class: _normalizeClass({ disabled: _ctx.head > 10 }),
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.moveToPlot('right'))),
                      disabled: _ctx.head > 10
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_ArrowRightOutlined)
                      ]),
                      _: 1
                    }, 8, ["class", "disabled"])
                  ]),
                  _createVNode(_component_a_button, {
                    class: _normalizeClass(["center", { disabled: _ctx.layer > 10 }]),
                    type: "default",
                    size: "small",
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.moveToPlot('down'))),
                    disabled: _ctx.layer > 10
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_component_ArrowDownOutlined)
                    ]),
                    _: 1
                  }, 8, ["class", "disabled"])
                ])
              ], 512), [
                [_vShow, !_ctx.renderState && _ctx.mode === 'single']
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _hoisted_73
    ]),
    _withDirectives(_createVNode(_component_MatrixView, { ref: "matrixView" }, null, 512), [
      [_vShow, !_ctx.renderState]
    ])
  ]))
}